import { PreloadedQuery } from "react-relay";

import { PricingContentContextProviderRelay } from "@/components/wpl/pricing/src/pricing-content-context.tsx";
// @ts-ignore
import { pricingPageRelayQuery } from "@/contentful/graphql/pricing-page";
import { TeamworkCollectionPricingPageTemplate } from "@/templates/collections/teamwork/pricing/teamwork-collection-pricing-page.template.tsx";
import { PricingContent } from "@/utils/pricing-queries/get-pricing-content-gql.ts";
import { UserLocale } from "@/utils/useGeoCurrency.ts";

import { AppPricingData } from "../../../../contentful/index.tsx";

export interface TeamworkCollectionPricingPageProps {
    pricing?: AppPricingData;
    countryCode?: UserLocale;
    pricingContent?: PricingContent;
    // @ts-ignore
    queryRef?: PreloadedQuery<typeof pricingPageRelayQuery>;
}

export const TeamworkCollectionPricingPage = (
    props: TeamworkCollectionPricingPageProps
) => {
    const { pricingContent, queryRef } = props;

    return (
        <PricingContentContextProviderRelay
            productId="teamwork-collection"
            pricingContent={pricingContent}
            // @ts-ignore
            queryRef={queryRef}
        >
            <TeamworkCollectionPricingPageTemplate />
        </PricingContentContextProviderRelay>
    );
};
